/**
 * Format a user's first/last name into a display string.
 * @param firstName - The user's first name
 * @param lastName - The user's last name
 * @param fallback - Fallback string if both names are empty (default: "Unknown User")
 * @returns Formatted display name
 */
export function formatUserName(
  firstName: string | null | undefined,
  lastName: string | null | undefined,
  fallback = "Unknown User",
): string {
  const parts = [firstName, lastName].filter(Boolean);
  return parts.length > 0 ? parts.join(" ") : fallback;
}

/**
 * Truncate a string to a max length, appending "..." if truncated.
 * @param text - The input string
 * @param maxLength - Maximum character count
 * @returns Truncated string
 */
export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + "...";
}
